import { useNavigate } from 'react-router';

import { ROUTE_SUPPLIERS_DASHBOARD } from '@/constants/router';
import { useGetAuditCase } from '@/queries/get-audit-case';
import { useAuditStore } from '@/store/auditStore';
import { useRouterStore } from '@/store/routerStore';
import { useTouchedFieldsStore } from '@/store/validationStore';

import { useAvailableActions } from './useAvailableActions';

export const useLeaveAudit = (auditCaseUuid: string) => {
  const { data: auditCase } = useGetAuditCase(auditCaseUuid);

  const resetFields = useTouchedFieldsStore((state) => state.resetFields);
  const resetRouter = useRouterStore((state) => state.resetRouter);
  const resetAudit = useAuditStore((state) => state.resetAudit);
  const setSubmitAuditModalCaseUuid = useRouterStore((state) => state.setSubmitAuditModalCaseUuid);
  const { setAvailableActions } = useAvailableActions();

  const navigate = useNavigate();

  const handleLeaveAudit = () => {
    if (!auditCase) {
      return;
    }

    resetFields();
    resetRouter();
    resetAudit();
    sessionStorage.clear();
    setSubmitAuditModalCaseUuid(null);
    setAvailableActions('auditCase', []);
    navigate(ROUTE_SUPPLIERS_DASHBOARD(auditCase?.supplierId));
  };

  return handleLeaveAudit;
};
